<template>
  <v-card>
    <v-list-item
        dark
        class="primary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-bell
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">System Notifications</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="minimize = !minimize">
          <v-icon v-if="!minimize">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-card-text v-if="!minimize" class="notifications-list pa-0">
      <v-sheet class="mt-0 pa-3 primary lighten-1">
        <v-text-field
            v-model="query"
            label="Search notification by category, type, sender or description"
            dark
            flat
            solo-inverted
            hide-details
            clearable
            clear-icon="mdi-close"
        >
        </v-text-field>
      </v-sheet>
      <v-progress-linear
          v-if="loading"
          indeterminate
      />
      <v-sheet class="pa-3 pb-1">
        <v-chip class="mr-2" @click.prevent="showAll" :class="Object.keys(filters).length ? '' : 'primary'">All</v-chip>
        <v-chip @click.prevent="showUnread" :class="filters['is_read'] === false ? 'primary' : ''">Unread ({{
            totalUnread
          }})
        </v-chip>
      </v-sheet>
      <v-container fluid>
        <v-data-iterator
            :items="items"
            :server-items-length="totalItems"
            :loading="loading"
            :options.sync="options"
            :footer-props="{
                    itemsPerPageOptions: [5, 10, 15, 30, -1]
                }"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                  v-for="item in props.items"
                  :key="item.name"
                  cols="12"
                  class="py-1 px-3"
              >
                <v-card>
                  <v-list-item
                      dense
                      dark
                      :class="[categoryColor(item.category, item.action), item.is_read ? '' : 'darken-2'].join(' ')"
                  >
                    <v-list-item-avatar v-if="!$vuetify.breakpoint.mobile">
                      <v-icon>{{ categoryIcon(item.category) }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                          :class="{'font-weight-bold' : item.is_read, 'text-wrap': $vuetify.breakpoint.mobile}"
                          v-text="item.short_description"
                      />
                      <v-list-item-subtitle>
                        {{ item.created | formatDate }} {{
                          item.source_display_name ? ` by
                        ${item.source_display_name}` : ''
                        }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.application_number" class="text-wrap">
                        <v-icon small>mdi-account-box-multiple</v-icon>
                        {{ item.application_number }}<br v-if="$vuetify.breakpoint.mobile"/>
                        <v-icon small>mdi-account</v-icon>
                        {{ item.main_applicant }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.category == 'System' && item.extra_data.version"
                                            class="text-wrap">
                        <v-icon small>mdi-git</v-icon>
                        version {{ item.extra_data.version }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action :class="{'ml-0': $vuetify.breakpoint.mobile}" class="my-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" dark icon @click="toggleRead(item)">
                            <v-icon v-if="item.is_read">mdi-checkbox-blank-circle</v-icon>
                            <v-icon v-else>mdi-checkbox-marked-circle</v-icon>
                          </v-btn>
                        </template>
                        <span v-if="item.is_read">Mark as unread</span>
                        <span v-else>Mark as read</span>
                      </v-tooltip>
                      <v-btn
                          v-if="item.category == 'System' && item.extra_data.version"
                          dark
                          icon
                          @click="reloadPage()"
                      >
                        <v-icon>mdi-reload</v-icon>
                      </v-btn>
                      <v-btn v-else :to="item.url|urlPath" dark icon>
                        <v-icon>mdi-page-next</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import debounce from "lodash.debounce";
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  name: 'SystemNotifications',
  data() {
    return {
      items: [],
      totalItems: 0,
      totalUnread: 0,
      // query: '',
      // options: {
      //     page: 1,
      //     itemsPerPage: 10,
      //     sortBy: [
      //         'created'
      //     ],
      //     sortDesc: [
      //         'created'
      //     ]
      // },
      // filters: {},
      // TODO: Look for better solution to avoid direct calls to store here
      query: this.$store.getters['search/notifications']['query'],
      options: this.$store.getters['search/notifications']['options'],
      filters: this.$store.getters['search/notifications']['filters'],
      loading: false,
      minimize: false,
    }
  },
  filters: {
    formatDate(date) {
      if (moment().diff(date, 'days') > 1) {
        return moment(date).format('lll')
      } else {
        return moment(date).fromNow()
      }
    },
    urlPath(url) {
      let parser = document.createElement('a');
      parser.href = url
      return '/' + parser.pathname.replace(/^\//, '')
    }
  },
  computed: {
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`)
    },
    searchParams() {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options

      let searchParams = {
        search: this.query,
        page_size: itemsPerPage,
        page: page,
        ordering: sortBy[0] ? (sortDesc[0] ? '-' : '') + sortBy : null
      }

      return Object.assign(searchParams, this.filters)
    }
  },
  watch: {
    query() {
      this.options['page'] = 1
      this.search()
    },
    filters() {
      this.options['page'] = 1
      this.search()
    },
    options: {
      handler() {
        this.search()
      },
      deep: true
    }
  },
  methods: {
    categoryColor(category, action) {
      let color = 'indigo'
      switch (category) {
        case 'Alert':
          color = 'secondary'
          if (action.toLowerCase() == 'confirm') {
            color = 'success'
          }
          break
        case 'Message':
          color = 'accent'
          break
        case 'Document':
          color = 'primary'
          break
        case 'System':
          color = 'blue-grey darken-1'
          break
      }
      return color
    },
    categoryIcon(category) {
      let icon = 'mdi-information'
      switch (category) {
        case 'Alert':
          icon = 'mdi-alert'
          break
        case 'Document':
          icon = 'mdi-file'
          break
        case 'Applicant':
          icon = 'mdi-account'
          break
        case 'Message':
          icon = 'mdi-chat'
          break
        case 'Application':
          icon = 'mdi-account-box-multiple'
          break
        case 'System':
          icon = 'mdi-update'
          break
      }
      return icon
    },
    fetchData() {
      this.loading = true

      this.fetchCounters()

      return new Promise((resolve, reject) => {
        this.$axios.get('/notifications/', {
          params: this.searchParams
        })
            .then((response) => {
              let items = []
              let total = 0
              if (response.data.results) {
                items = response.data.results
                total = response.data.count
              } else {
                items = response.data
                total = items.length
              }
              this.loading = false
              resolve({
                items,
                total
              })
            })
            .catch((e) => {
              this.loading = false
              reject(e)
            })
      })
    },
    fetchCounters() {
      this.$axios.get('/notifications/count/unread/', {params: this.searchParams})
          .then((response) => {
            this.totalUnread = response.data.count
          })
          .catch(() => {
            this.totalUnread = '-'
          })
    },
    search: debounce(
        function () {
          this.fetchData()
              .then(data => {
                this.items = data.items
                this.totalItems = data.total
              })
              .catch((error) => {
                errorNotification(error)
              })
              .finally(() => {
                this.loading = false
              })
          this.$store.dispatch('search/save', {
            component: 'notifications',
            params: {
              query: this.query,
              filters: this.filters,
              options: this.options
            }
          })
        },
        600),
    toggleRead(notification) {
      notification.is_read = !notification.is_read
      this.$axios.patch(`/notifications/${notification.id}/read/`, {
        'is_read': notification.is_read
      })
          .then(() => {
            this.fetchCounters()
          })
    },
    showAll() {
      this.filters = {}
    },
    showUnread() {
      this.filters = {
        'is_read': false
      }
    },
    reloadPage() {
      window.location.reload()
    }
  },
  mounted() {
    this.search()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.notifications-list {
  .v-alert:last-child {
    margin-bottom: 0;
  }
}

.v-list-item {
  border-radius: 3px !important;
}
</style>